import React, { Component } from "react";
import Helmet from "react-helmet";
import Layout from "../layout";
import { Link, graphql, StaticQuery } from "gatsby";
import WashingtonDCSkylineLight from "../images/sila-life/virginia/washington-dc-line-drawing.svg";
import PostListing from "../components/Post/PostListing";
import BackgroundImage from "gatsby-background-image";
import ArlingtonPostings from "../components/Lever/ArlingtonPostings";
import config from "../../data/SiteConfig";

export default () => {
  return (
    <StaticQuery
      query={graphql`
        query {
          silaLife: allFile(
            filter: {
              relativeDirectory: { eq: "sila-life/virginia" }
              extension: { ne: "svg" }
            }
          ) {
            edges {
              node {
                name
                childImageSharp {
                  fluid(quality: 100, maxWidth: 640) {
                    ...GatsbyImageSharpFluid
                  }
                }
              }
            }
          }
          internshipVideos: allMarkdownRemark(
            filter: {
              frontmatter: {
                category: { eq: "Video" }
                title: { regex: "/Internship/" }
              }
            }
          ) {
            edges {
              node {
                fields {
                  slug
                }
                frontmatter {
                  title
                  youtubeId
                  category
                  tags
                  thumb {
                    childImageSharp {
                      fluid(maxWidth: 350, quality: 100) {
                        ...GatsbyImageSharpFluid_noBase64
                      }
                    }
                    extension
                    publicURL
                  }
                  youtubeId
                }
              }
            }
          }
        }
      `}
      render={data => {
        const silaLifePhotos = data.silaLife.edges.map(silaLifePhoto => {
          return {
            name: silaLifePhoto.node.name,
            fluid: silaLifePhoto.node.childImageSharp.fluid,
            path: silaLifePhoto.node.childImageSharp.fluid.src
          };
        });
        const silaRonaldMcdonald = silaLifePhotos.find(
          silaLifePhoto =>
            silaLifePhoto.name === "sila-at-ronald-mcdonald-house"
        ).path;
        const silaSkiing = silaLifePhotos.find(
          silaLifePhoto => silaLifePhoto.name === "sila-goes-skiing"
        ).path;
        const silaSwitzerland = silaLifePhotos.find(
          silaLifePhoto => silaLifePhoto.name === "sila-in-switzerland"
        ).path;
        const silaToughMudder = silaLifePhotos.find(
          silaLifePhoto => silaLifePhoto.name === "sila-tough-mudder"
        ).path;
        const silaPaintNite = silaLifePhotos.find(
          silaLifePhoto => silaLifePhoto.name === "sila-va-paint-nite"
        ).path;
        const silaKilimanjaro = silaLifePhotos.find(
          silaLifePhoto => silaLifePhoto.name === "sila-at-kilimanjaro"
        ).path;
        const bagelsCoffee = silaLifePhotos.find(
          silaLifePhoto => silaLifePhoto.name === "bagels-coffee"
        ).path;
        const foodTruck = silaLifePhotos.find(
          silaLifePhoto => silaLifePhoto.name === "food-truck"
        ).path;
        const bridgeTrails = silaLifePhotos.find(
          silaLifePhoto => silaLifePhoto.name === "bridge-trails"
        ).path;
        const pingPong = silaLifePhotos.find(
          silaLifePhoto => silaLifePhoto.name === "ping-pong"
        ).path;
        const metroBg = silaLifePhotos.find(
          silaLifePhoto => silaLifePhoto.name === "dc-metro-bg"
        ).fluid;
        const postEdges = data.internshipVideos.edges;
        return (
          <Layout>
            <>
              <Helmet
                title={`Sila Life in Arlington, VA | ${config.siteTitle}`}
              />
              <section className="location-graphic-header arlington">
                <img
                  className="location-graphic"
                  alt="The Washington, DC skyline which can be seen across the water from Arlington, Virginia"
                  src={WashingtonDCSkylineLight}
                />
              </section>
              <section className="st-pad-vert">
                <div className="container text-center">
                  <div className="full">
                    <div className="restrict wide">
                      <h1>Sila Life in Arlington, VA</h1>
                      <p>
                        Arlington, VA is known for its wonderful parks, schools,
                        transportation system, and of course, being minutes from
                        downtown Washington, DC. With our headquarters in
                        Arlington, our consultants have access to endless
                        events, world-class museums, great sports teams (go
                        Caps!), and an ideal jumping off point for adventures,
                        whether by plane, train, or automobile.
                      </p>
                      <p>
                        Our DC-based consultants are solving challenges for our
                        clients across the nation, with a healthy mix of local
                        and non-local clients. We are also pleased to have been
                        recognized by Indeed Prime as a {}
                        <a
                          href="https://www.indeed.com/prime/resources/talent/20-amazing-tech-companies-hiring-in-washington-dc"
                          target="_blank"
                        >
                          Top 20 Tech Company Hiring in DC
                        </a>
                        . Browse our <a href="#openings">Arlington openings</a>.
                      </p>
                    </div>
                  </div>
                </div>
              </section>
              <section>
                <h2 className="h3 text-center">We Are Sila Arlington</h2>
                <div className="container make-block">
                  <div
                    className="culture-collage__two-thirds"
                    style={{
                      background: `url(${silaRonaldMcdonald}) center top no-repeat`,
                      backgroundSize: `cover`
                    }}
                  />
                  <div
                    className="culture-collage__one-third"
                    style={{
                      background: `url(${silaSkiing}) center top no-repeat`,
                      backgroundSize: `cover`
                    }}
                  />
                  <div
                    className="culture-collage__one-third"
                    style={{
                      background: `url(${silaSwitzerland}) center top no-repeat`,
                      backgroundSize: `cover`
                    }}
                  />
                  <div
                    className="culture-collage__two-thirds"
                    style={{
                      background: `url(${silaToughMudder}) center top no-repeat`,
                      backgroundSize: `cover`
                    }}
                  />
                  <div
                    className="culture-collage__two-thirds"
                    style={{
                      background: `url(${silaPaintNite}) center center no-repeat`,
                      backgroundSize: `cover`
                    }}
                  />
                  <div
                    className="culture-collage__one-third"
                    style={{
                      background: `url(${silaKilimanjaro}) center top no-repeat`,
                      backgroundSize: `cover`
                    }}
                  />
                </div>
              </section>

              <h3 className="h2 text-center st-pad-top">A Day in the Life</h3>

              <section className="location-story arlington">
                <section className="st-pad-vert light-on-dark">
                  <div className="container">
                    <div className="story-caption">
                      <h3>Kickstart your day</h3>
                      <p>
                        For our Metro riders, we're only a block from Rosslyn
                        station. Drivers, you can enjoy on-site parking. If
                        you're local, there's a Capital Bikeshare station right
                        outside. Take your pick for your morning commute—and may
                        we recommend a quick stop at Compass Coffee for cold
                        brew on the way in?
                      </p>
                      <p>
                        Of course, everyone looks forward to Bagel Fridays in
                        the office kitchen before our weekly team meeting (where
                        we get to know our new hires a little better with a game
                        of Two Truths and a Lie).
                      </p>
                    </div>

                    <div className="story-illustration">
                      <img
                        alt="Cups of hot and iced coffee alongside a bagel with cream cheese"
                        src={bagelsCoffee}
                      />
                    </div>
                  </div>

                  <div className="cloud-border-top no-marg-bot" />
                </section>

                <section>
                  <div className="container">
                    <div className="story-illustration">
                      <img
                        alt="Two ping pong paddles and a ping pong ball stacked in preparation for some friendly competition between coworkers"
                        src={pingPong}
                      />
                    </div>

                    <div className="story-caption">
                      <h3 className="light-blue-text">Break time</h3>
                      <p>
                        For those of us supporting clients in-office rather than
                        on-site, ping pong is our go-to for unwinding between
                        tasks. If getting outside is more your style, head to
                        Freedom Park for a game of bocce or go for a run on one
                        of the local trails. Board game aficionados interested
                        in a little friendly competition after hours—look out
                        for our biweekly game night!
                      </p>
                    </div>
                  </div>
                </section>

                <section className="st-pad-vert no-marg-bot">
                  <div className="cloud-border-bottom" />
                  <div className="container">
                    <div className="story-caption">
                      <h3 className="light-blue-text">Hungry?</h3>
                      <p>
                        Forgot your lunch? No worries, head down the hill and
                        hit up one of the many food trucks. Once a month, you
                        can also join us for a Bag of Bacon (ask about it during
                        your interview), where you’ll learn something new and
                        enjoy late afternoon refreshments! And join our
                        recruiting team for Recruiting Rodeos, where we help you
                        connect with your network.
                      </p>
                    </div>

                    <div className="story-illustration">
                      <img
                        alt="A food truck ready to serve lunch in Rosslyn, Virginia"
                        src={foodTruck}
                      />
                    </div>
                  </div>
                </section>

                <section className="no-marg-top xt-pad-vert light-on-dark">
                  <div className="container">
                    <div className="story-illustration">
                      <img
                        alt="An outdoor scene demonstrating city attractions across the Key Bridge and trails around and beneath it"
                        src={bridgeTrails}
                      />
                    </div>

                    <div className="story-caption">
                      <h3>Out on the town</h3>
                      <p>
                        We work hard and we can play even harder. We host
                        monthly social events across the DMV. Head across the
                        Key Bridge to Georgetown for bowling, catch a baseball
                        game at Nats Park, or channel your inner artist at Paint
                        Nite. For adventure-seekers, there's no shortage of
                        hiking, biking, climbing, and running. (If you're
                        feeling brave, sign up for our annual Tough Mudder!) For
                        the more relaxed crowd, we have a family-friendly
                        weekend winery event and, of course, our annual picnic.
                      </p>
                    </div>
                  </div>
                </section>
              </section>
              <section className="st-pad-vert">
                <div className="container">
                  <div className="full text-center">
                    <h4>
                      Our interns made a difference in one summer, for both Sila
                      and themselves.
                    </h4>
                    <p>Watch to learn more about our DC-based team!</p>
                  </div>
                </div>
                <div className="fill-flex-space">
                  <PostListing postEdges={postEdges} />
                </div>
              </section>
              <BackgroundImage
                Tag="section"
                fluid={metroBg}
                className="location-map st-pad-vert"
              >
                <div className="container">
                  <div className="full text-center">
                    <h3>Our Location</h3>
                    <p>
                      We are located at{" "}
                      <a
                        href="https://goo.gl/maps/z2F7v97iQi62"
                        target="_blank"
                      >
                        1300 Wilson Blvd, Suite 1100, Arlington, VA 22209
                      </a>
                      .<br />
                      Our parking garage is off Fort Meyer Drive. Take the
                      elevator up to the 11th floor.
                    </p>
                    <div className="responsive-map-embed">
                      <iframe
                        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3105.291137456375!2d-77.0747847482815!3d38.89445715462047!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89b7b6595c83773d%3A0x3879bcd97630c252!2sSila+Solutions+Group!5e0!3m2!1sen!2sus!4v1530563193479"
                        width="600"
                        height="450"
                        frameborder="0"
                        style={{ border: 0 }}
                        allowfullscreen
                      />
                    </div>
                  </div>
                </div>
              </BackgroundImage>
              <section id="openings">
                <div className="container">
                  <div className="full restrict">
                    <h3 className="text-center margin-bottom">
                      Open Positions in Arlington
                    </h3>
                    <ArlingtonPostings />
                  </div>
                </div>

                <div className="container text-center">
                  <div className="full">
                    <p>
                      If you don't see a role that fits your profile, please{" "}
                      <a
                        href="https://jobs.lever.co/silasg/a71c995c-f564-4b04-8968-da6702c4d664/apply"
                        target="_blank"
                      >
                        submit a general application
                      </a>
                      .
                    </p>
                    <p>
                      <a
                        href="https://jobs.lever.co/silasg/a71c995c-f564-4b04-8968-da6702c4d664/apply"
                        target="_blank"
                        className="button primary"
                      >
                        Apply Now
                      </a>
                    </p>
                  </div>
                </div>
              </section>
            </>
          </Layout>
        );
      }}
    />
  );
};
